import React from 'react';
import ReactDOM from 'react-dom';
import RingFileUploadNxUI from './components/FileUploadNxUI';
import { HashRouter } from 'react-router-dom';
import './i18n'

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <RingFileUploadNxUI />
        </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
